import axios from "axios"
import { docCookies } from "../utils/docCookies"
import { ApiHelper, axiosInstance } from "../utils/ApiHelper"
import { startSubmit, stopSubmit, reset } from "redux-form"
import { SubmissionError } from "redux-form"
import { notification } from "antd"
import { routerMiddleware, push, replace } from "react-router-redux"
import AnalyticsHelper from "../utils/AnalyticsHelper"
import CloudEvent from "../utils/CloudEvent"
import { routerActionCreators } from "../store/configureStore"
import { matchPath } from "react-router"
import moment from "moment"

const queryString = require("query-string")

// NOTE use if authenticating through a popup window:

// export function showIntegration(new_account_token) {
//   return dispatch => {
//     // third party integration was successful
//
//     dispatch({
//       type: "SHOW_INTEGRATION_REQUEST",
//       new_account_token
//     })
//     ApiHelper.showFreshbooksAccount(new_account_token).then(({ data }) => {
//       dispatch({
//         type: "SHOW_INTEGRATION_SUCCESS",
//         payload: data
//       })
//     })
//   }
// }

export function showIntroVideo() {
  return dispatch => {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1
    if (localStorage.getItem("introVideoShown") === null && !isFirefox) {
      localStorage.setItem("introVideoShown", true)
      dispatch({
        type: "SHOW_MODAL",
        modalType: "INTRO_VIDEO_MODAL",
        modalProps: {
          title: "Everlance for the Web!",
          message:
            "We have been hard at work and excited to announce our new web dashboard."
        }
      })
    }
  }
}
const showOneTimeWelcomeMessage = () => {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1

  if (localStorage.getItem("introVideoShown") === null && !isFirefox) {
    // localStorage.setItem('introVideoShown', true)
    // notification['info']({
    //   message: 'Welcome to the Beta!',
    //   description: 'Pardon our dust as we are still developing features. Let us know what you think at support@everlance.com!',
    //   duration: 0,
    //   placement: 'topLeft'
    // })
  }
}

export function resetPassword(email) {
  return dispatch => {
    dispatch({ type: "RESET_PASSWORD_REQUEST" })
    // Update email subscriptions with server
    return axiosInstance.post("password_resets/", { email }).then(response => {
      if (response.status != 200) {
        // Error
        dispatch({
          type: "RESET_PASSWORD_FAIL",
          formErrorMessage: response.data.error_message
        })
        return response
      } else {
        // Success
        dispatch({
          type: "RESET_PASSWORD_SUCCESS"
        })
        return response
      }
    })
  }
}

export function checkEmail({ email }) {
  return (dispatch, getState) => {
    const { location } = getState().router

    dispatch({ type: "CHECK_EMAIL_REQUEST" })

    return ApiHelper.checkEmail(email).then(response => {
      const { next_action } = response.data
      dispatch({
        type: "CHECK_EMAIL_SUCCESS",
        next_action,
        email
      })
      dispatch(redirectTo(next_action == "sign_in" ? "/login" : "/signup"))
      return response
    }, error => error)
  }
}

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE"
export const USER_REQUEST = "USER_REQUEST"
export const USER_SUCCESS = "USER_SUCCESS"
export const USER_FAILURE = "USER_FAILURE"
function userRequest() {
  return {
    type: USER_REQUEST
  }
}
function userSuccess(json) {
  var properties = {}
  properties[CloudEvent.Premium] = !!json.subscription
  properties[CloudEvent.Email] = json.email
  properties[CloudEvent.Phone] = json.mobile
  properties[CloudEvent.FirstName] = json.name
  properties[CloudEvent.LastName] = json.last
  properties[CloudEvent.Vehicles] = json.vehicles.length
  properties[CloudEvent.FavoritePlaces] = json.places.length
  properties[CloudEvent.FavoriteTrips] = json.favorite_trips.length
  properties[CloudEvent.FreeTripsRemaining] = json.free_trips_remaining
  properties[CloudEvent.TrialDaysRemaining] = json.trial_days_remaining
  properties[CloudEvent.InstitutionUserCount] =
    json.institution_users && json.institution_users.length
  properties[CloudEvent.BluetoothDeviceCount] =
    json.devices && json.devices.length
  properties[CloudEvent.HasReceivedInviteClient] =
    json.received_invites.filter(invite => invite.type == "InviteClient")
      .length > 0
  properties[CloudEvent.HasSentInviteAccountant] =
    json.sent_invites.filter(invite => invite.type == "InviteAccountant")
      .length > 0
  properties[CloudEvent.HasSentInviteManager] =
    json.sent_invites.filter(invite => invite.type == "InviteManager").length >
    0
  properties[CloudEvent.ClientUser] = json.group_as_client != null
  properties[CloudEvent.AccountantUser] = json.group_as_accountant != null
  if (json.income_sources.length > 0) {
    properties[CloudEvent.IncomeSources] = json.income_sources
  }
  AnalyticsHelper.identify(json)
  AnalyticsHelper.addPeopleProperty(json.token_id, properties)
  AnalyticsHelper.trackEvent(CloudEvent.DashboardLoadUser)

  // explicitly list all keys that we are using:
  const {
    integration_accounts,
    integrations_enabled,
    email,
    token_id,
    name,
    last,
    mobile,
    average_tax_rate,
    auto_detect_enabled,
    income_sources,
    custom_purposes,
    custom_expense_categories,
    auto_classify,
    kms_enabled,
    weekly_report_enabled,
    monthly_report_enabled,
    promotions_enabled,
    yearly_report_enabled,
    push_notifications_enabled,
    // ios_app_version,
    ios_device_model,
    // ios_device_version,
    // android_app_version,
    android_device_model,
    // android_device_version,
    // ios_app_badge_enabled,
    // remote_logging_enabled,
    // ios_idfa,
    // android_ad_id,
    persona,
    // beacon_enabled,
    // utm_campaign,
    // utm_source,
    // utm_content,
    // utm_term,
    // utm_medium,
    // taxes_cta,
    // premium_offer,
    // main_copy,
    // sub_copy,
    // call_to_action_url,
    // call_to_action_text,
    // taxes_image_url,
    // modal_type_after_moment_of_joy,
    // should_show_to_new_users_only,
    // show_home_rate_card,
    subscription,
    group_as_accountant,
    group_as_client,
    group_as_cobrand_member,
    group_as_enterprise_member,
    group_as_enterprise_owner,
    sent_invites, //array
    received_invites,
    vehicles,
    places,
    favorite_trips,
    favorite_transactions,
    transactions,
    // uncategorized_transactions: [],
    institution_users,
    trips,
    // uncategorized_trips,
    // devices,
    // created_at,
    work_hours,
    // institutions_list,
    irs_mileage_rates,
    // inspirational_quote,
    work_mileage_rate,
    custom_mileage_rate,
    total_revenue,
    total_expenses,
    total_trips_deductions,
    total_standard_method_expenses,
    total_standard_method_revenue,
    total_miles,
    total_uncategorized_miles,
    total_business_miles,
    total_personal_miles,
    total_medical_miles,
    total_charity_miles,
    total_moving_miles,
    total_other_miles,
    total_kms,
    total_uncategorized_kms,
    total_business_kms,
    total_personal_kms,
    total_medical_kms,
    total_charity_kms,
    total_moving_kms,
    total_other_kms,
    // unique_uncategorized_trip_dates,
    // unique_trip_dates,
    // unique_uncategorized_transaction_dates,
    // unique_transaction_dates,
    total_uncategorized_trips_count,
    total_uncategorized_transactions_count,
    // referral_code_name,
    // invited_by_code,
    trial_days_remaining
    // free_trips_remaining
  } = json

  // const filtered = ['id', 'name'].reduce((result, key) => { result[key] = orig[key]; return result; }, {});

  const bankAccounts = institution_users.reduce(
    (a, c) => a.concat(c.institution_accounts),
    []
  )
  const bankNames = bankAccounts.map(ba => ba && ba.meta)

  return {
    type: USER_SUCCESS,
    user: {
      integration_accounts,
      integrations_enabled,
      email,
      token_id,
      name,
      last,
      mobile,
      average_tax_rate,
      auto_detect_enabled,
      income_sources,
      custom_purposes,
      custom_expense_categories,
      auto_classify,
      kms_enabled,
      weekly_report_enabled,
      monthly_report_enabled,
      promotions_enabled,
      yearly_report_enabled,
      push_notifications_enabled,
      // ios_app_version,
      ios_device_model,
      // ios_device_version,
      // android_app_version,
      android_device_model,
      // android_device_version,
      // ios_app_badge_enabled,
      // remote_logging_enabled,
      // ios_idfa,
      // android_ad_id,
      persona,
      // beacon_enabled,
      // utm_campaign,
      // utm_source,
      // utm_content,
      // utm_term,
      // utm_medium,
      // taxes_cta,
      // premium_offer,
      // main_copy,
      // sub_copy,
      // call_to_action_url,
      // call_to_action_text,
      // taxes_image_url,
      // modal_type_after_moment_of_joy,
      // should_show_to_new_users_only,
      // show_home_rate_card,
      subscription,
      group_as_accountant,
      group_as_client,
      group_as_cobrand_member,
      group_as_enterprise_member,
      group_as_enterprise_owner,
      sent_invites, //array
      received_invites,
      vehicles,
      places,
      favorite_trips,
      favorite_transactions,
      transactions,
      // uncategorized_transactions: [],
      institution_users,
      bankAccounts,
      bankNames,
      trips,
      // uncategorized_trips,
      // devices,
      // created_at,
      work_hours,
      // institutions_list,
      irs_mileage_rates,
      // inspirational_quote,
      work_mileage_rate,
      custom_mileage_rate,
      total_revenue,
      total_expenses,
      total_trips_deductions,
      total_standard_method_expenses,
      total_standard_method_revenue,
      total_miles,
      total_uncategorized_miles,
      total_business_miles,
      total_personal_miles,
      total_medical_miles,
      total_charity_miles,
      total_moving_miles,
      total_other_miles,
      total_kms,
      total_uncategorized_kms,
      total_business_kms,
      total_personal_kms,
      total_medical_kms,
      total_charity_kms,
      total_moving_kms,
      total_other_kms,
      // unique_uncategorized_trip_dates,
      // unique_trip_dates,
      // unique_uncategorized_transaction_dates,
      // unique_transaction_dates,
      total_uncategorized_trips_count,
      total_uncategorized_transactions_count,
      // referral_code_name,
      // invited_by_code,
      trial_days_remaining
      // free_trips_remaining
    },
    receivedAt: Date.now()
  }
}

export function getUser() {
  return (dispatch, getState) => {
    let { isFetching } = getState().models.user
    if (isFetching) return console.log("already fetching user")

    dispatch(userRequest())

    return ApiHelper.getUser().then(
      response => {
        dispatch(userSuccess(response.data))
        dispatch(redirectAuthedIfNeeded())
      },
      error => {
        dispatch({ type: "USER_FAILURE" })
        dispatch(logout())
        dispatch(redirectUnAuthedIfNeeded())
      }
    )
  }
}

export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST"
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS"
export const CREATE_USER_FAILURE = "CREATE_USER_FAILURE"
function createUserRequest() {
  return {
    type: CREATE_USER_REQUEST,
    isFetching: true,
    isAuthenticated: false
  }
}
function createUserSuccess(json, status) {
  docCookies.setItem("auth_token", json.auth_token)
  axiosInstance.defaults.headers["Authorization"] =
    "Token token=" + json.auth_token

  AnalyticsHelper.alias(json)
  var properties = {}
  var eventProperties = {}
  properties[CloudEvent.Email] = json.email
  properties[CloudEvent.Phone] = json.mobile
  properties[CloudEvent.SignUpDate] = moment().format("MMM D, h:mm A")
  properties[CloudEvent.FirstName] = json.name
  properties[CloudEvent.LastName] = json.last
  properties[CloudEvent.Vehicles] = json.vehicles.length
  properties[CloudEvent.FavoritePlaces] = json.places.length
  properties[CloudEvent.FavoriteTrips] = json.favorite_trips.length
  properties[CloudEvent.FreeTripsRemaining] = json.free_trips_remaining
  properties[CloudEvent.TrialDaysRemaining] = json.trial_days_remaining
  properties[CloudEvent.InstitutionUserCount] = json.institution_users.length
  properties[CloudEvent.BluetoothDeviceCount] = json.devices.length
  properties[CloudEvent.HasReceivedInviteClient] =
    json.received_invites.filter(invite => invite.type == "InviteClient")
      .length > 0
  properties[CloudEvent.HasSentInviteAccountant] =
    json.sent_invites.filter(invite => invite.type == "InviteAccountant")
      .length > 0
  properties[CloudEvent.HasSentInviteManager] =
    json.sent_invites.filter(invite => invite.type == "InviteManager").length >
    0
  properties[CloudEvent.ClientUser] = json.group_as_client != null
  properties[CloudEvent.AccountantUser] = json.group_as_accountant != null

  if (json.utm_campaign) {
    properties[CloudEvent.UTMCampaign] = json.utm_campaign
    eventProperties[CloudEvent.UTMCampaign] = json.utm_campaign
  }
  if (json.utm_source) {
    properties[CloudEvent.UTMSource] = json.utm_source
    eventProperties[CloudEvent.UTMSource] = json.utm_source
  }
  if (json.utm_term) {
    properties[CloudEvent.UTMTerm] = json.utm_term
    eventProperties[CloudEvent.UTMTerm] = json.utm_term
  }
  if (json.utm_medium) {
    properties[CloudEvent.UTMMedium] = json.utm_medium
    eventProperties[CloudEvent.UTMMedium] = json.utm_medium
  }
  if (json.utm_content) {
    properties[CloudEvent.UTMContent] = json.utm_content
    eventProperties[CloudEvent.UTMContent] = json.utm_content
  }
  if (json.income_sources.length > 0) {
    properties[CloudEvent.IncomeSources] = json.income_sources
  }
  AnalyticsHelper.addPeopleProperty(json.token_id, properties)
  AnalyticsHelper.trackEvent(CloudEvent.SignUp, eventProperties)

  return {
    type: CREATE_USER_SUCCESS,
    user: json,
    receivedAt: Date.now(),
    isFetching: false,
    isAuthenticated: true,
    createUserResponseStatus: status
  }
}
function createUserFailure(json, status) {
  return {
    type: CREATE_USER_FAILURE,
    receivedAt: Date.now(),
    isFetching: false,
    isAuthenticated: false,
    createUserResponseStatus: status,
    json: json
  }
}
export function createUser(data) {
  return (dispatch, getState) => {
    const query_data = getState().user
    delete query_data.password
    delete query_data.email

    dispatch(createUserRequest())

    data.mixpanel_distinct_id =
      window.mixpanel.get_distinct_id && window.mixpanel.get_distinct_id()

    return ApiHelper.createUser(data, query_data).then(
      json => {
        dispatch(createUserSuccess(json.data, json.status))
        dispatch(redirectTo("step-one"))

        // dispatch(showIntroVideo())

        return json
      },
      error => {
        dispatch(createUserFailure(error.data, error.status))
        dispatch(redirectUnAuthedIfNeeded())
      }
    )
  }
}

export const LOGIN_REQUEST = "LOGIN_REQUEST"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAILURE = "LOGIN_FAILURE"
function loginRequest() {
  return {
    type: LOGIN_REQUEST,
    isFetching: true,
    isAuthenticated: false
  }
}
function loginSuccess(json, status) {
  docCookies.setItem("auth_token", json.auth_token)
  axiosInstance.defaults.headers["Authorization"] =
    "Token token=" + json.auth_token

  AnalyticsHelper.identify(json)
  AnalyticsHelper.trackEvent(CloudEvent.SignIn)

  return {
    type: LOGIN_SUCCESS,
    user: json,
    receivedAt: Date.now(),
    isFetching: false,
    isAuthenticated: true,
    loginResponseStatus: status
  }
}

function loginFailure(json, status) {
  return {
    type: LOGIN_FAILURE,
    receivedAt: Date.now(),
    isFetching: false,
    isAuthenticated: false,
    loginResponseStatus: status,
    json: json
  }
}

export function login(data) {
  return (dispatch, getState) => {
    let { isFetching } = getState().models.user
    if (isFetching) return console.log("already logging in user")
    // mock testing slt token
    if (data.single_login_token === "test") {
      delete data.single_login_token
      data.email = "testslt@test.com"
      data.password = "testslt@test.com"
    }

    dispatch(loginRequest())

    const query_data = getState().user
    delete query_data.password
    delete query_data.email

    return ApiHelper.login(data, query_data).then(
      response => {
        dispatch(loginSuccess(response.data, response.status))
        dispatch(handleParams())

        dispatch(redirectAuthedIfNeeded())
        return response
      },
      error => {
        dispatch(loginFailure(error.data, error.status))
        dispatch(redirectUnAuthedIfNeeded())
      }
    )
  }
}

export const LOGOUT_REQUEST = "LOGOUT_REQUEST"
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS"
function logoutRequest() {
  return {
    type: LOGOUT_REQUEST,
    isFetching: true,
    isAuthenticated: true
  }
}
function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS,
    auth_token: null,
    isFetching: false,
    isAuthenticated: false
  }
}

export function logout() {
  return dispatch => {
    dispatch(logoutRequest())
    axiosInstance.defaults.headers["Authorization"] = ""
    docCookies.removeItem("auth_token")
    dispatch(logoutSuccess())
    AnalyticsHelper.clearUserCookie()
    dispatch(redirectUnAuthedIfNeeded())
  }
}

export function handleParams() {
  return (dispatch, getState) => {
    const { location } = getState().router
    const { pathname, search, hash } = location
    const { token_id, isAuthenticated } = getState().models.user
    const { hasOnboarded } = getState().user

    if (search) {
      const {
        rm_before_auth,
        rm_after_auth,
        plan,
        redirect_to,
        signup_type,
        coupon,
        slt
      } = queryString.parse(search)

      if (slt) {
        dispatch({ type: "@@router/LOCATION_REMOVE_PARAM", payload: "slt" })
      }

      // set state for: slt, plan, signup_type, coupon, plan
      if (rm_before_auth)
        dispatch({
          type: "@@router/LOCATION_REMOVE_PARAM",
          payload: "rm_before_auth"
        })

      if (plan)
        dispatch({
          type: "@@router/LOCATION_SET",
          payload: {
            state: {
              ...location.state,
              pathname: "premium"
            }
          }
        })

      // wait till we have the user authenticated...
      if (isAuthenticated && token_id) {
        if (rm_after_auth)
          dispatch({
            type: "@@router/LOCATION_REMOVE_PARAM",
            payload: "rm_after_auth"
          })
        if (signup_type) {
          dispatch({
            type: "@@router/LOCATION_SET",
            payload: {
              // pathname:signup_type,
              state: { pathname: signup_type }
            }
          })
          dispatch({
            type: "@@router/LOCATION_REMOVE_PARAM",
            payload: "signup_type"
          })
        }
      }
    }
  }
}

export function redirectAfterOnboarding() {
  return (dispatch, getState) => {
    const { location } = getState().router
    const { pathname, search, hash } = location
    const { redirect_to } = queryString.parse(search)

    dispatch(push(redirect_to || "dashboard"))
  }
}

export function replaceParams() {
  return (dispatch, getState) => {
    const { location } = getState().router
    const {
      isOnPublicOnlyPath,
      pathname,
      hasUserData,
      hasAuthCookie
    } = location

    dispatch(handleParams())

    dispatch(
      replace({
        ...location
      })
    )
  }
}

export function redirectIfNeeded() {
  return (dispatch, getState) => {
    const { location } = getState().router
    const {
      isOnPublicOnlyPath,
      pathname,
      hasUserData,
      hasAuthCookie
    } = location

    if (hasUserData) {
      dispatch(redirectAuthedIfNeeded())
    }
    if (
      !hasUserData &&
      !hasAuthCookie // comment this line to force login screen if fetching user
    ) {
      dispatch(redirectUnAuthedIfNeeded())
    }
  }
}

export function redirectAuthedIfNeeded() {
  return (dispatch, getState) => {
    const { location } = getState().router
    const { isOnPublicOnlyPath, pathname } = location
    dispatch(handleParams())

    if (isOnPublicOnlyPath) {
      dispatch({
        type: "@@router/LOCATION_SET",
        payload: {
          ...location, // for stripped out params
          ...(location.state || { pathname: "/dashboard" })
        }
      })

      dispatch(renderLocation())
    }
  }
}

export function redirectUnAuthedIfNeeded() {
  return (dispatch, getState) => {
    const { location } = getState().router
    const { pathname, isOnPublicOnlyPath, isOnPublicAndPrivatePath } = location
    dispatch(handleParams())

    if (isOnPublicAndPrivatePath) return

    if (!isOnPublicOnlyPath) {
      dispatch({
        type: "@@router/LOCATION_SET",
        payload: {
          pathname: "/start",
          state: location
        }
      })

      dispatch(renderLocation())
    }
  }
}

export function renderLocation() {
  return (dispatch, getState) => {
    dispatch(
      push({
        ...getState().router.location
      })
    )
  }
}

export function redirectTo(pathname) {
  return (dispatch, getState) => {
    dispatch({ type: "@@router/LOCATION_SET", payload: { pathname } })
    dispatch(renderLocation())
  }
}



// WEBPACK FOOTER //
// ./src/user/actions.js